module.exports = __webpack_public_path__ + "b59d01a71e3624b4120d0fdaf56ff969.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/language-switcher.html
// module id = 1058
// module chunks = 0